import React, { FC, useContext, useEffect } from "react";
import { PrimaryHeader } from "../../components/header/primary";
import { DashboardHeaderContext } from "../../../hook/header";
import { ByRequestVehicleControlGroup } from "./request";
import { useStyleContext } from "../../context/StyleContext";

export const VehicleControlGroupPage: FC = () => {
  const dashboardHeaderContext = useContext(DashboardHeaderContext);
  const { stylePage } = useStyleContext();
  /* eslint-disable */
  useEffect(() => {
    dashboardHeaderContext.setTheme({
      className: "bg-secondary-header",
      title: "Control Vehicular",
      dark: true,
    });
  }, []);
  /* eslint-enable */

  return (
    <div className={"w-full overflow-x-hidden"} style={stylePage}>
      <PrimaryHeader
        breadcrumbItems={[
          {
            label: "Control Vehicular",
            active: true,
          },
        ]}
        title={"Control Vehicular"}
      />
      <div className={"w-full p-3"}>
        <ByRequestVehicleControlGroup />
      </div>
    </div>
  );
};
